import { getErrorText } from '../../../common/api/errors'
import { escapeHtml } from '../../../common/escapeHtml'

/**
 * Validation message of the "complete payout" dialog: the backend's reason in the dialog's frame, escaped —
 * `showValidationMessage()` renders HTML.
 */
export const finishRefusalMessage = (error: unknown): string =>
  escapeHtml(`Неверный запрос: ${getErrorText(error, 'невозможно завершить тикет')}`)
